import { type RecordId } from '../types';
import type DataStoreWidgets from '../collaboration/DataStoreWidgets';
import DataStoreRecordBehaviors, {
  type SerializeKey,
} from '../collaboration/DataStoreRecordBehaviors';
import {
  type SerializedWidget,
  type WidgetType,
  type BaseSerializedWidget,
  commonSerializedKeys,
} from '.';

/**
 * Widget is a catchall for anything on the whiteboard that isn't drawn by the canvas,
 * but is canvas adjacent - timers, votes, video-call style temporary drawing, etc.
 *
 * To add a new widget, create a new class extending BaseWidget. You can use the
 * WidgetController (available everywhere WhiteboardController is available) to read/write
 * widgets, and any change to serializedKeys (including creation/deletion) will be sent to
 * collaborators.
 */
class BaseWidget
  extends DataStoreRecordBehaviors(Object)
  implements BaseSerializedWidget
{
  serializedKeys: SerializeKey[] = [...commonSerializedKeys];
  id: RecordId;
  authorId?: RecordId;
  type: WidgetType;

  _dataStore: DataStoreWidgets;

  constructor(attributes: Partial<SerializedWidget> = {}) {
    super();

    Object.assign(this, attributes);
  }

  // Used by the Whiteboard to render all its widgets. Each component
  // must be given a unique key prop for optimal React performance.
  render(): JSX.Element | null {
    throw new Error(`render() not defined for widget`);
  }

  belongsToUser(authorId?: RecordId | null): boolean {
    return this.authorId === authorId;
  }
}

export default BaseWidget;
